import { Filter } from "@aionzdev/design-system";

export enum OrderByColumn {
  UPDATED_AT = 'updatedAt',
  CREATED_AT = 'createdAt',
  EXPECTED_DELIVERY_DATE = 'dataEntregaEsperada'
}
export type OrderDirection = 'asc' | 'desc';

export interface OrderBy {
  key: OrderByColumn;
  order: OrderDirection;
}

export interface FindAllPurchasesRequestDto {
  currentPage?: number;
  take?: number;
  filters?: Filter[];
  search?: string;
  orderBy?: OrderBy;
}
